import React from 'react';
import PropTypes from 'prop-types';

import {Button, Stack, TextCharLimit, FreeSoloDropdown} from 'views/components';
import {Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {Translate, translate} from 'views/module';

const CaregiverNameEdit = (props) => {
  const [contactType, setContactType] = React.useState('');
  const [contactDetail, setContactDetail] = React.useState('');

  const {
    caregiverBackend,
    isEditing,
    setIsEditing,
  } = props;

  const onSave = () => {
    caregiverBackend.detail.addContact(contactType, contactDetail, () => {
      setIsEditing(false);
    });
  };

  const isValid = () => {
    return !Boolean(contactType && contactDetail);
  };

  const onClose = () => {
    setIsEditing(false);
  };

  return (
    <Dialog onClose={onClose} open={isEditing}>
      <DialogTitle onClose={onClose}>
        <Translate expression='caregiver.CaregiverDetail.Settings.Contact.CreateNew.Action' />
      </DialogTitle>
      <DialogContent>
        <Stack
          sx={{
            m: 1,
          }}
          spacing={1}
        >
          <FreeSoloDropdown
            options={[
              translate('caregiver.CaregiverDetail.Settings.Contact.CreateNew.ContactTypeExample.Email'),
              translate('caregiver.CaregiverDetail.Settings.Contact.CreateNew.ContactTypeExample.PhoneNumber'),
              translate('caregiver.CaregiverDetail.Settings.Contact.CreateNew.ContactTypeExample.EmergencyContact'),
            ]}
            label={translate('caregiver.CaregiverDetail.Settings.Contact.CreateNew.ContactType')}
            onChange={setContactType}
            value={contactType}
          />
          <TextCharLimit
            label={translate('caregiver.CaregiverDetail.Settings.Contact.CreateNew.ContactDetail')}
            value={contactDetail}
            onChange={setContactDetail}
            charLimit={180}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Close' />
        </Button>
        <Button color="error" disabled={isValid()} onClick={onSave}>
          <Translate expression='generic.Save' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

CaregiverNameEdit.propTypes = {
  caregiverData: PropTypes.object.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
  isEditing: PropTypes.bool.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(CaregiverNameEdit);
